import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import ContactFinder from '../../components/FloatingContact/components/ContactFinder/ContactFinder.vue';

type ContactFinderTypes = InstanceType<typeof ContactFinder>['$props']['type'];

export type FloatingContactView =
  | 'fab_closed'
  | 'fab_l1'
  | 'fab_l2_finder'
  | 'fab_l2_navigation'
  | 'fab_l2_interactive';

export type FinderMode = ContactFinderTypes;

// TODO(tracking): GA context type if needed
// export type Context = 'Website' | 'Worldwide' | 'Shop';

export const useFloatingContactStore = defineStore('floatingContact', () => {
  const view = ref<FloatingContactView>('fab_closed');
  const finderMode = ref<FinderMode>('input');

  // GA context if needed
  // const context = ref<Context>('DE');

  const isOpen = computed(() => view.value !== 'fab_closed');
  const isClosed = computed(() => view.value === 'fab_closed');

  const isL1 = computed(() => view.value === 'fab_l1');

  const isL2 = computed(() => {
    return view.value.startsWith('fab_l2_');
  });

  const isFinder = computed(() => {
    return view.value === 'fab_l2_finder';
  });

  const isNavigation = computed(() => view.value === 'fab_l2_navigation');
  const isInteractive = computed(() => view.value === 'fab_l2_interactive');

  // TODO(tracking):
  // function baseEventPayload(cat?: string, extra?: {}) {
  //   return {
  //     cat: cat,
  //     page_path: window.location.pathname,
  //     ...extra,
  //   };
  // }

  // ---------------------------------------------------------------------------
  // actions (state machine transitions)
  // ---------------------------------------------------------------------------

  function fab_open() {
    view.value = 'fab_l1';

    // TODO(tracking): GA opened
    // window.wtTrack.({
    //   event: 'fab_opened',
    //   ...baseEventPayload({
    //     entry_level: 'l1',
    //   }),
    // });
  }

  function fab_close() {
    view.value = 'fab_closed';

    // TODO(tracking): GA closed
    // window.wtTrack.({
    //   event: 'fab_closed',
    //   ...baseEventPayload({
    //     close: 'closed',
    //   }),
    // });
  }

  function openL1() {
    view.value = 'fab_l1';
  }

  function openFinder(mode: FinderMode) {
    view.value = 'fab_l2_finder';
    finderMode.value = mode;

    // TODO(tracking): GA open finder + mode
    // window.wtTrack.({
    //   event: 'fab_l2_opened',
    //   ...baseEventPayload({
    //     l2_target: 'finder',
    //     finder_mode: mode,
    //   }),
    // });
  }

  function openNavigation() {
    view.value = 'fab_l2_navigation';

    // TODO(tracking): GA open contact navigation
    // window.wtTrack.({
    //   event: 'fab_l2_opened',
    //   ...baseEventPayload({
    //     l2_target: 'navigation',
    //   }),
    // });
  }

  function openInteractive() {
    view.value = 'fab_l2_interactive';

    // TODO(tracking): GA open chatbot
    // window.wtTrack.(
    //   cat: 'LIVECHATBOT',
    //   extra: {
    //   event: 'fab_l2_opened',
    //   ...baseEventPayload({
    //     l2_target: 'interactive',
    //   }),
    // });
  }

  function backToL1() {
    view.value = 'fab_l1';

    // TODO(tracking): go back
    // window.wtTrack.({
    //   event: 'fab_l2_back',
    //   ...baseEventPayload({
    //     target: 'l1',
    //   }),
    // });
  }

  return {
    view,
    finderMode,
    // TODO(tracking) if needed: context,

    // derived
    isOpen,
    isClosed,
    isL1,
    isL2,
    isFinder,
    isNavigation,
    isInteractive,

    // actions
    fab_open,
    fab_close,
    openL1,
    openFinder,
    openNavigation,
    openInteractive,
    backToL1,
  };
});
